import script from "./PowerDialerBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PowerDialerBanner.vue?vue&type=script&setup=true&lang=js"

import "./PowerDialerBanner.vue?vue&type=style&index=0&id=860494cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-860494cc"]])

export default __exports__